export class Benefit {
    constructor(title: string){
        this.title = title;
        this.items = [];
    }
    title: string;
    icon: string;
    items: string[];
}